import { api } from './api-client';

export interface BiSummary {
  period: string;
  revenue: number;
  profit: number;
  arBalance: number;
  arCount: number;
  apBalance: number;
  apCount: number;
  cashBalance: number;
  revenueChange: number;
  profitChange: number;
}

export interface PoStats {
  total: number;
  draft: number;
  confirmed: number;
  partialReceived: number;
  received: number;
  monthlyAmount: number;
}

export interface ReportsBundle {
  bi: BiSummary;
  po: PoStats;
}

export async function fetchReports(): Promise<ReportsBundle> {
  const [biRes, poRes] = await Promise.all([
    api.get<BiSummary>('/finance/reports/bi/summary'),
    api.get<PoStats>('/scm/purchase-orders/stats'),
  ]);
  return { bi: biRes.data, po: poRes.data };
}
